export default __webpack_public_path__ + "static/media/PornHub.4bae57fd.jpg";